import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'reactstrap';
import EditorIndex from "./editor/index"
import EventBus from "./editor/eventBus"
import ToolStore, { POINTER, PEN, LINE, ELLIPSE, RECT, ARROW, NOTHING } from './editor/toolStore';
import html2canvas from "html2canvas"
import { useDispatch, useSelector } from "react-redux"
import * as Actions from "../../../store/actions"
import Swal from 'sweetalert2';
import Store from './editor/store';

const EditingScreenShot = props => {

    const dispatch = useDispatch()

    const [ButtonSelected, setButtonSelected] = useState("line")
    const [ShowAngle, setShowAngle] = useState(false)
    // const [IsLoading, setIsLoading] = useState(false)
    const [Text, setText] = useState([])

    // console.log(Store.history, Store.historyIndex)



    useEffect(() => {
        EventBus.emit(EventBus.COLOR_CHANGE, "blue");

        if (!props.isFromRom) {
            EventBus.emit(EventBus.PICK_VERSION, 0);
            EventBus.emit(EventBus.TOOL_CHANGE, LINE)
        }
    }, [])


    return (
        (
            <div className="EditingScreenShotSection">
                <div className="heading">
                    <p>
                        {
                            props.isFromRom ? `Edit the picture here, and when you are done press the save button!` : `Select any screenshot and click the "Next" Button to start editing it.`
                        }
                    </p>
                </div>
                <div className="EditingScreenShotContiner">
                    <div className="THE_CONTAINTER_OF_MAGIC">
                        <div
                            id="theEditor"
                            className="theImgDummyForNow"
                            style={{
                                backgroundImage: `url(${props?.theImg})`,
                                // backgroundImage: `url(/images/background.jpg)`,
                                backgroundPosition: "center"
                            }}>
                            <EditorIndex
                                Text={Text}
                                ShowAngle={ShowAngle}
                                HideAngle={() => setShowAngle(false)}
                                SelectedNuller={() => setButtonSelected("")}
                                newSelection={() => setButtonSelected("newSelection")}
                                setAngle={props.setAngle ? (e) => props.setAngle(e) : () => { }}
                            />

                        </div>
                        {
                            !props.isFromRom ? (
                                <button onClick={() => {
                                    props.onSelectAnotherPicture()
                                    EventBus.emit(EventBus.PICK_VERSION, 0);
                                }} className="selectOtherButton">
                                    Select other Picture
                                </button>
                            ) : null
                        }
                    </div>
                    <div className="tools" style={{ paddingTop: props.isFromRom ? "0px" : "20px" }}>
                        <span>
                            Tools
                            
                        </span>
                        <div className="toolsContainer">
                            <div>
                                <button
                                    onClick={() => {
                                        if (ButtonSelected == "arrow") {
                                            EventBus.emit(EventBus.TOOL_CHANGE, NOTHING)

                                            return setButtonSelected("")
                                        }
                                        EventBus.emit(EventBus.TOOL_CHANGE, ARROW)

                                        setButtonSelected("arrow")
                                    }}
                                    className={`tool ${ButtonSelected == "arrow" ? "activeTool" : ""}`}>

                                    <img src={`/images/manual/${ButtonSelected == "arrow" ? "white" : "blue"}/arrow.svg`} />
                                </button>
                                <p>
                                    Arrow
                                </p>
                            </div>

                            <div>
                                <button
                                    onClick={() => {
                                        if (ButtonSelected == "line") {
                                            EventBus.emit(EventBus.TOOL_CHANGE, NOTHING)

                                            return setButtonSelected("")
                                        }
                                        EventBus.emit(EventBus.TOOL_CHANGE, LINE)
                                        setButtonSelected("line")
                                    }}
                                    className={`tool ${ButtonSelected == "line" ? "activeTool" : ""}`}>
                                    <img src={`/images/manual/${ButtonSelected == "line" ? "white" : "blue"}/line.svg`} />

                                </button>

                                <p>
                                    Line
                                </p>
                            </div>
                            <div>
                                <button
                                    disabled={props.Step == 2}
                                    onClick={() => {
                                        // if (ButtonSelected == "angel") return setButtonSelected("")
                                        if (ShowAngle) {
                                            return setShowAngle(false)
                                        }
                                        setButtonSelected("");
                                        setShowAngle(true)
                                        EventBus.emit(EventBus.TOOL_CHANGE, NOTHING)

                                        setButtonSelected("angel")
                                    }}
                                    className={`tool ${ShowAngle ? "activeTool" : ""} ${props.Step == 2 ? "NoHover" : ""} `}>
                                    <img src={`/images/manual/${ShowAngle ? "white" : "blue"}/angle.svg`} />

                                </button>

                                <p>
                                    Angle
                                </p>
                            </div>
                            <div>
                                <button
                                    onClick={() => {
                                        if (ButtonSelected == "circle") {
                                            EventBus.emit(EventBus.TOOL_CHANGE, NOTHING)

                                            return setButtonSelected("")
                                        }
                                        EventBus.emit(EventBus.TOOL_CHANGE, ELLIPSE)

                                        setButtonSelected("circle")
                                    }}
                                    className={`tool ${ButtonSelected == "circle" ? "activeTool" : ""}`}>
                                    <img src={`/images/manual/${ButtonSelected == "circle" ? "white" : "blue"}/circle.svg`} />

                                </button>
                                <p>
                                    Circle
                                </p>
                            </div>
                            <div>
                                <button
                                    onClick={() => {
                                        if (ButtonSelected == "Square") {
                                            EventBus.emit(EventBus.TOOL_CHANGE, NOTHING)
                                            return setButtonSelected("")

                                        }

                                        EventBus.emit(EventBus.TOOL_CHANGE, RECT)

                                        setButtonSelected("Square")
                                    }}
                                    className={`tool ${ButtonSelected == "Square" ? "activeTool" : ""}`}>
                                    <img src={`/images/manual/${ButtonSelected == "Square" ? "white" : "blue"}/square.svg`} />

                                </button>
                                <p>
                                    Square
                                </p>
                            </div>
                            <div>
                                <button
                                    onClick={async () => {
                                        // if (ButtonSelected == "text") return setButtonSelected("")

                                        const res = await Swal.fire({
                                            title: 'Enter a text',
                                            input: 'text',
                                            inputAttributes: {
                                                autocapitalize: 'off'
                                            },
                                            showCancelButton: true,
                                            confirmButtonText: 'Save',
                                        })

                                        setText([...Text, { text: res.value || "", color: Store.color }])
                                        // setButtonSelected("text")
                                    }}
                                    className={`tool ${ButtonSelected == "text" ? "activeTool" : ""}`}>
                                    <img src={`/images/manual/${ButtonSelected == "text" ? "white" : "blue"}/T.svg`} />

                                </button>
                                <p>
                                    Text
                                </p>
                            </div>
                            <div>
                                <button
                                    onClick={() => {
                                        if (ButtonSelected == "free") {
                                            EventBus.emit(EventBus.TOOL_CHANGE, NOTHING)

                                            return setButtonSelected("")
                                        }
                                        EventBus.emit(EventBus.TOOL_CHANGE, PEN)

                                        setButtonSelected("free")
                                    }}
                                    className={`tool ${ButtonSelected == "free" ? "activeTool" : ""}`}>
                                    <img src={`/images/manual/${ButtonSelected == "free" ? "white" : "blue"}/pen.svg`} />

                                </button>
                                <p>
                                    Pen
                                </p>
                            </div>
                            <div>
                                <button
                                    onClick={() => {
                                        if (ButtonSelected == "newSelection") {
                                            EventBus.emit(EventBus.TOOL_CHANGE, NOTHING)

                                            return setButtonSelected("")
                                        }
                                        EventBus.emit(EventBus.TOOL_CHANGE, POINTER)

                                        setButtonSelected("newSelection")
                                    }}
                                    className={`tool ${ButtonSelected == "newSelection" ? "activeTool" : ""}`}>
                                    <img src={`/images/manual/${ButtonSelected == "newSelection" ? "white" : "blue"}/moveIcon.svg`} />

                                </button>
                                <p>
                                    Move
                                </p>
                            </div>

                            <div>
                                <button
                                    onClick={() => {
                                        // EventBus.emit(EventBus.PICK_VERSION, Store.historyIndex.length);
                                        Store.undo()

                                        // if (ButtonSelected == "newSelection") return setButtonSelected("")
                                        // EventBus.emit(EventBus.TOOL_CHANGE, POINTER)

                                        // setButtonSelected("newSelection")
                                    }}
                                    className={`tool ${false ? "activeTool" : ""}`}>
                                    <img src={`/images/manual/${false ? "white" : "blue"}/undo-arrow.svg`} />

                                </button>
                                <p>
                                    Undo
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="NextButton" style={{ justifyContent: props.isFromRom && !props.IsLoading ? "space-between" : "flex-end" }}>
                    {
                        props.isFromRom && !props.IsLoading ? (
                            <Button
                                onClick={() => {
                                    props.onSelectAnotherPicture()
                                    // EventBus.emit(EventBus.PICK_VERSION, 0);
                                }}
                                color="secondary"
                                style={{ width: "100px" }}>
                                Back
                            </Button>
                        ) : null
                    }
                    <Button
                        onClick={() => {
                            if (props.IsLoading) return
                            props.onSave()
                        }}
                        color="primary"
                        style={{ width: "100px" }}>
                        {
                            props.IsLoading ? "Loading..." : (props.Step == 2 && props.isFromRom ? "Next" : "Save")
                        }
                    </Button>
                </div>

            </div>
        )
    )
}

EditingScreenShot.propTypes = {
    onSelectAnotherPicture: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    IsLoading: PropTypes.bool.isRequired,
    SelectedID: PropTypes.string,
    theImg: PropTypes.string.isRequired,
    isFromRom: PropTypes.bool.isRequired,
    setAngle: PropTypes.func,
}

export default EditingScreenShot
